import React from "react";
import { TitleWithSearch } from "../../components/titleWithSearch";
import backHeader from "../../assets/img/Back - Header.svg";
import notDelete from "../../assets/img/Icon awesome-exclamation-circle.svg";
import "../../assets/styles/insumos.css";
import { useParams } from "react-router-dom";
import { TrocaTelas } from "../../components/trocaTelas";
import { Pagination, Stack } from "@mui/material";
import { ModalInfos } from "../../components/modal";
import { ModalSure } from "../../components/modalExcluir";
import axiosInstance from "../../auth/axiosInstance";

export default function Insumos() {
  const param = useParams()
  const [labelError, setlabelError] = React.useState({ label: 'Erro ao adicionar Insumo!', sugestao: 'Favor revisar dados e tentar novamente' })
  const [searchValue, setSearchValue] = React.useState("");
  const [values, setValues] = React.useState({});
  const [initialData, setInitialData] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false)
  const [showModal2, setShowModal2] = React.useState(false)
  const [showModal3, setShowModal3] = React.useState(false)
  const [label, setlabel] = React.useState('Projeto atualizado com sucesso!')
  const [insumosId, setInsumoId] = React.useState(0)
  const [selected, setSelected] = React.useState(null);
  const [insumoSelecionado, setInsumoSelecionado] = React.useState({})

  const onChange = (event) => {
    setValues({
      ...values, [event.target.name]:
        event.target.value
    });
  };

  React.useEffect(() => {
    getInitial()
  }, [])

  async function getInitial() {
    await axiosInstance(`filter/Eap_Insumos_Custo/${param.id}`)
      .then(res => {
        setInitialData(res.data)
      })
  }

  const getUpdates = async () => {
    // await sessionStorage.clear();
    axiosInstance(`filter/Eap_Insumos_Custo/${param.id}`)
      .then(res => {
        setInitialData(res.data)
      })
  }

  async function putGeral(sheet, id, eapid) {
    await axiosInstance.put(`filter/${sheet}/${id}/${eapid}`, values)
      .then(res => {
        if (res.status === 200) {
          setlabel('Projeto atualizado com sucesso!')
          setShowModal(true)
          animationModal('modal-new-action', 'background-new-plan')
          setValues({})
          getUpdates()
          setTimeout(() => {
            getInitial()
          }, 100);
        }
      })
      .catch(error => {
        setlabelError({ label: 'Erro ao editar Insumo!', sugestao: 'Favor tente novamente' })
        setShowModal2(true)
        setShowModal3(false)
      })
  }

  async function deleteInsumos() {
    try {
      await axiosInstance.delete(`filter/Insumos/${insumosId}`)
        .then(res => {
          if (res.status === 200) {
            setlabel('Insumo removido com sucesso!')
            setShowModal(true)
            setValues({})
            getUpdates()
            filteredData = initialData
            setShowModal3(false)
            setTimeout(() => {
              getInitial()
            }, 100);
          }
        })
    } catch (error) {
      setlabelError({ label: 'Erro ao deletar Insumo!', sugestao: 'Favor tente novamente' })
      setShowModal2(true)
      setShowModal3(false)
    }

  }

  function animationModal(id, id2) {
    let div = document.getElementById(id)
    let background = document.getElementById(id2)
    let param = background.style.visibility
    if (param === 'hidden' || param === '') {
      background.style.visibility = 'visible'
      setTimeout(() => {
        div.classList.add('modal-new-action-aberto')
      }, 100);
    } else {
      div.classList.remove('modal-new-action-aberto')
      setTimeout(() => {
        background.style.visibility = 'hidden'
        const inputs = document.querySelectorAll('input, textarea, select');

        for (let i = 0; i < inputs.length; i++) {
          inputs[i].value = '';
        }
      }, 300);
    }
  }

  const [page, setPage] = React.useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const paginate = (array, page_size, page_number) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const searchHandler = ({ target }) => {
    setSearchValue(target.value);
    setPage(1);
  };

  let filteredData = searchValue
    ? initialData.filter((value) =>
      Object.values(value)
        .join(" ")
        .toLowerCase()
        .includes(searchValue.toLowerCase())
    )
    : initialData;

  const paginatedData = paginate(filteredData, 30, page);
  const totalPages = Math.ceil(filteredData.length / 30);



  return (
    <section className="body-table-eap">
      <div style={{ display: 'flex', width: '93%', justifyContent: 'space-between' }}>
        < TitleWithSearch
          title='Insumos'
          label='Pesquisar Insumos'
          chevron={true}
          route={`/eap/${param.id}`}
          placeholder='Pesquise por Cód. Desc. Unidade Moeda Índice e Custo'
          onChange={searchHandler}
        />

      </div>

      <TrocaTelas route={`/eap/${param.id}/${param.cpu}`} />
      <div style={{ maxHeight: '61%' }} className="table-wrapper">
        <table style={selected !== null ? { width: '85%' } : { width: '95%' }} className="table-eap table-insumos">
          <thead>
            <tr>
              <th>Categoria</th>
              <th >Código</th>
              <th className="text-center">Descrição</th>
              <th className="text-center">Unidade</th>
              <th className="text-center">Moeda</th>
              <th className="text-center">Custo</th>
              <th className="text-center">Custo Convertido</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map(element => (
              <tr onClick={selected !== null && element === selected ? () => setSelected(null) : () => setSelected(element)} className="tr-body-eap">
                <td>{element.categoria}</td>
                <td>{element.insumoId}</td>
                <td >{element.descricao}</td>
                <td className="text-center">{element.unidade}</td>
                <td className="text-center">{element.moeda}</td>
                <td className="text-center">{(element.custo).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                <td className="text-center">{(element.custoConvertido).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                <div style={selected === element ? { display: 'flex' } : { display: 'none' }} className="options-cpu">
                  <button onClick={() => { setShowModal3(true); setInsumoId(element.insumoId) }}>
                    Excluir
                  </button>
                  <button onClick={() => { animationModal('modal-new-action', 'background-new-plan'); setInsumoSelecionado(element) }}>
                    Editar
                  </button>
                </div>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="page-component">
          <Stack spacing={2}>
            <Pagination count={totalPages} page={page} onChange={handleChange} />
          </Stack>
        </div>
      </div>

      <div id="background-new-plan" className="background-new-plan">
        <section id="modal-new-action" className="modal-new-action">
          <div onClick={() => animationModal('modal-new-action', 'background-new-plan')} className="fechar-button-style spacing">
            <div className="close">
              <img src={backHeader} alt="back" />
              <img src={backHeader} alt="back" />
              <h2 className="montserrat ">Fechar</h2>
            </div>
          </div>
          <h1 className="montserrat azul w600">Alterar Insumo</h1>
          <div>
            <div className="content-inputs">
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Moeda</h3>
                </div>
                <select name="moeda" onChange={onChange}>
                  <option>Selecione o Tipo</option>
                  <option>BRL</option>
                  <option>USD</option>
                  <option>EUR</option>
                  <option>CLP</option>
                  <option>COP</option>
                  <option>MXN</option>
                </select>
                <h4 className="montserrat">EXEMPLO: BRL</h4>
              </div>
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Custo</h3>
                </div>
                <input name="custo" onChange={onChange} placeholder='Write here' type='number' />
                <h4 className="montserrat">EXEMPLO: 1000</h4>
              </div>
            </div>
          </div>
          <div className="button-okay-modal">
            <button className="montserrat w600" onClick={() => animationModal('modal-new-action', 'background-new-plan')} >Cancelar</button>
            <button className="montserrat w600"
              onClick={() => putGeral('Eap_Insumos_Custo', insumoSelecionado.insumoId, param.id)}
              disabled={Object.keys(values).length > 0 && !Object.values(values).some(value => value.trim() === "") ? false : true}
              style={Object.keys(values).length > 0 && !Object.values(values).some(value => value.trim() === "") && !Object.values(values).includes(' ') ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }}>Alterar</button>
          </div>
        </section>
      </div>
      <div className="background-new-plan remove-div" id="id-remove">
        <section id="modal-new-action-remove" className="modal-remove">
          <img src={notDelete} alt="Icone" />
          <span className="modal-remove-span">Você deseja realmente excluir esse Insumo ?</span>
          <div className="modal-remove-buttons">
            <button className="button dont" onClick={() => animationModal('modal-new-action-remove', 'id-remove')}>Não</button>
            <button className="button yes">Sim</button>
          </div>
        </section>
      </div>

      <ModalInfos
        checked={showModal}
        onClick={() => setShowModal(false)}
        label={label}
      />

      <ModalInfos
        checked={showModal2}
        error
        onClick={() => setShowModal2(false)}
        label={labelError.label}
        sugestao={labelError.sugestao}
      />

      <ModalSure
        checked={showModal3}
        error
        label='Você realmente deseja exluir esse Insumo?'
        onClick={() => setShowModal3(false)}
        delete={() => deleteInsumos()}
      />
    </section >
  )
}
